import { render, staticRenderFns } from "./Interviews.vue?vue&type=template&id=a54813a6&scoped=true&"
import script from "./Interviews.vue?vue&type=script&lang=ts&"
export * from "./Interviews.vue?vue&type=script&lang=ts&"
import style0 from "./Interviews.vue?vue&type=style&index=0&id=a54813a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54813a6",
  null
  
)

export default component.exports